import React, {useRef, useState, useId, useEffect, useContext} from 'react';
import { GlobalStateContext } from '../GlobalState';
import Select from 'react-select';
import {Chatbot} from '../../states/actions';
import {Handle, useStore} from 'reactflow';
import {onEdit} from '../../helpers/block-helper';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import {ckEditorBasic} from '../../config';
import logger from '../../utils/logger';


/* Using window object to store data for short user interaction processes.
Using this to load node editor only on clicking on certain node element.
--> so progress selection or any other extra function would not trigger
loading editor.
 */
const setNode = (node) => {
  window.el = node.id;
}
export function blockIconSrc(icon) {
  return icon === 'gtm' ? '/images/icons/gtm.svg' : `/images/icons/${icon}.png`;
}

export const onEdited = (e) => {
  window.isEdited = true;
 /*  window.handleInput = e.target.value;
  logger.log(e.target.value)
  logger.log(window.isEdited) */
}

/* export const InputComponent = ({data, name, dataname, placeholder, onBlur, onLoad, icon}) => {  

    return (
      <>
      <div className="mb-2">
      <label htmlFor={dataname} className="form-label comp-header">
       {name}<i><b>{icon}</b></i>
      </label>
       <input
          type="input"
          id={dataname}
          name={dataname}
          className="form-control"
          placeholder={placeholder}
          defaultValue={data[dataname]}
          onBlur={onBlur}
          onLoad={onLoad}
          onChange={onEdited}
          />
      </div>
    </>
    );
} */

  export const InputComponent = ({
    data,
    name,
    dataname,
    placeholder,
    onBlur,
    onLoad,
    icon,
    language, // Added language prop
  }) => {

  const dataValue = data?.[dataname];
  const [value, setValue] = useState(dataValue ?? '');

  useEffect(() => {
    setValue(dataValue ?? '');
  }, [language, dataname, dataValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
    logger.log("set:" , e.target.value)
    if (onEdited) {
      onEdited(e);
    }
  };

  return (
    <div className="mb-2">
      <label htmlFor={dataname} className="form-label comp-header">
        {name}<i><b>{icon}</b></i>
      </label>
      <input
        type="input"
        id={dataname}
        name={dataname}
        value={value}
        className="form-control"
        placeholder={placeholder}
        onBlur={onBlur}
        onLoad={onLoad}
        onChange={handleChange}
      />
    </div>
  );
};

export const ButtonState = ({block, data, dataname, label, startstate}) => {
  let state = "";
  switch (data[dataname]) {
    case true:
      state = true;
      break;
    case false:
      state = false;
      break;
    case undefined:
      state = startstate;
      break;
    default:
      state = true;
      break;
  }
  const [buttonstate, setButtonState] = useState(state);
  function setActive(e){
    logger.log("THISISSTATE", state, startstate)

    state = buttonstate ? false : true;
    setButtonState(state); 
    Chatbot.setBlockData(block.id, {[dataname]: state}) 
    onEdited()
 }

return (
    <>
      {/* <div className="mb-2">
            <label htmlFor="button" className="form-label">
              Active
            </label>
            <input
              type="checkbox"
              id="button"
              name="button"
              className="ml-2"
              defaultChecked={data.button}
              onBlur={(e) => Chatbot.setBlockData(block.id, {[e.target.name]: e.target.checked})}
            />
      </div> */}

      <div className='btn-switch' onClick={(e) => {setActive(e)} } >
            <div  
                  className={`switch ${buttonstate ? 'on' : 'off'}`}>
                  <span></span>
             </div>
            <span className='text'>{label}</span>
      </div>
     
    </> 
)
}

export const ButtonSwitch = ({block, data, dataname, label1, state1, label2, state2, name}) => {
  let state = state1;
  switch (data[dataname]) {
    case state1:
      state = state1;
      break;
    case state2:
      state = state2;
      break;
    default:
      state = state1;
      break;
  }
  const [buttonstate, setButtonState] = useState(state);
  function setActive(e){
    state = buttonstate === state2 ? state1 : state2
    setButtonState(state); 
    Chatbot.setBlockData(block.id, {[dataname]: state}) 
    onEdited()
 }

return (
    <>
      {/* <div className="mb-2">
            <label htmlFor="button" className="form-label">
              Active
            </label>
            <input
              type="checkbox"
              id="button"
              name="button"
              className="ml-2"
              defaultChecked={data.button}
              onBlur={(e) => Chatbot.setBlockData(block.id, {[e.target.name]: e.target.checked})}
            />
      </div> */}

 

      <div className="mb-2">
      <label className="form-label comp-header">
       {name}
      </label>
      <div className='btn-switch' onClick={(e) => {setActive(e)}}>
           <span className='text'>{label1}</span>
            <div  
                  className={`switch ${buttonstate === state2 ? 'on' : 'off'}`}>
                  <span></span>
             </div>
            <span className='text'>{label2}</span>
      </div>

      </div>
     
    </> 
)
}

/* THIS HAS ISSUES in saving data, fixed? */
export const TextareaComponent = ({data, name, dataname, placeholder, rows, onBlur, defaultValue, icon}) => {
  return (
    <>
           <div className="mb-2">
                  <label htmlFor={dataname} className="form-label comp-header">
                    {name}<i><b>{icon}</b></i>
                  </label>
                  <textarea
                    id={dataname}
                    name={dataname}
                    defaultValue={defaultValue ? defaultValue : data[dataname]}
                    placeholder={placeholder}
                    onBlur={onBlur}
                    onChange={onEdited}
                    className="form-control"
                    rows={rows}
                  ></textarea>
      </div>  
  </>
  );
}

export const RichTextareaComponent = ({data, name, dataname, placeholder, rows, onBlur, defaultValue, icon, block}) => {
  return (
    <>
           <div className="mb-2">
                  <label htmlFor={dataname} className="form-label comp-header">
                    {name}<i><b>{icon}</b></i>
                  </label>
                 
                  <CKEditor
                    config={ckEditorBasic}
                    editor={ClassicEditor}
                    data={data[dataname]}
                    onChange={onEdited}
                    onBlur={(e, editor) => {
                      Chatbot.setBlockData(block.id, {[dataname]: editor.getData()});
                      /* if(data.notification.length < 1){showNotification(false)}  */
                    }}
                  />
      </div>  
  </>
  );
}


/* not in use */

export const SelectComponent = ({data, name, dataname, placeholder, options, block, onChange, onLoad, ref}) => {

  return (
    <>
              <div className="mb-2">
                  <label htmlFor={dataname} className="form-label comp-header">
                    {name}
                  </label>
                    <Select
                      className="form-control form-control-sm editor-select"
                      placeholder={placeholder}
                      id={dataname}
                      classNamePrefix="editor-select"
                      name={dataname}
                      ref={ref}
                      defaultValue = "input"
                      options={options}
                      onChange={onChange}
                      onLoad={onLoad}
                      value={options.find((item) => item.value === data[dataname])}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderRadius: 0,
                          border: 'none',
                        }),
                      }}
                    />
        
               </div>


    {/* <div className="mb-2">
                  <label htmlFor="validation" className="form-label">
                    Validation Rule
                  </label>
                  <Select
                    id="validation"
                    name="validation"
                    options={validations}
                    placeholder="Type"
                    value={validations.find((i) => i.value === data.validation)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onChange={(option) => {
                      Chatbot.setBlockData(block.id, {validation: option.value});
                    }}
                  />
                </div> */}
  </>
  );
}

export const SelectComp = ({data, name, dataname, dataname2, placeholder, options, block, value, value2, sort, multi = false}) => {



  return (
    <>
    


              {multi ? (
                 <> 
                   <div className="mb-2">
                   <label htmlFor="validation" className="form-label comp-header">
                     {name}
                   </label>
                  <Select
                    className="form-control form-control-sm editor-select"
                    classNamePrefix="editor-select"
                    placeholder={placeholder}
                    id={dataname}
                    name={dataname}
                    defaultValue="input"
                    options={options}
                    onChange={(selectedOptions) => {
                      const primaryKey = value || 'value';
                      const secondaryKey = value2 || 'value';
                      const assign = {
                        ...data,
                        [dataname]: selectedOptions
                          ? selectedOptions.map((option) => option[primaryKey])
                          : [],
                      };
                      if (dataname2) {
                        assign[dataname2] = selectedOptions
                          ? selectedOptions.map((option) => option[secondaryKey])
                          : [];
                      }
                      delete assign.undefined;
                      Chatbot.setBlockData(block.id, {assign});
                      onEdited();
                    }}

                    /* Chatbot.setBlockData(block.id, {
                      assign: {...data, lawyers: option.map((i) => i.value), lawyerEmails: option.map((i) => i.email)},
                    }); */

                    value={options?.filter((option) => data[dataname]?.includes(option[value ? value : 'value']))}
                    //value={options?.filter(option => data[dataname].includes(option[value ? value : 'value']))}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            borderRadius: 0,
                            border: 'none',
                        }),
                    }}
                    isClearable={true}  // This prop enables the "x" clear icon
                    isMulti={multi}
                    required
                />
        
             </div>

              </>
            ) : (
              <>

              <div className="mb-2">
              <label htmlFor="validation" className="form-label comp-header">
                {name}
              </label>
                <Select
                className="form-control form-control-sm editor-select"
                classNamePrefix="editor-select"
                placeholder={placeholder}
                id={dataname}
                name={dataname}
                defaultValue="input"
                options={options}
                onChange={(option) => {
                    Chatbot.setBlockData(block.id, {[dataname]: option ? option[value ? value : 'value'] : ''});
                    onEdited();
                }}
                value={options.find((item) => item[value ? value : 'value'] === data[dataname])}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        borderRadius: 0,
                        border: 'none',
                    }),
                }}
                isClearable={true}  // This prop enables the "x" clear icon
                required
              />
            </div>

            </>
            
            )}

  
             

    {/* <div className="mb-2">
                  <label htmlFor="validation" className="form-label">
                    Validation Rule
                  </label>
                  <Select
                    id="validation"
                    name="validation"
                    options={validations}
                    placeholder="Type"
                    value={validations.find((i) => i.value === data.validation)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onChange={(option) => {
                      Chatbot.setBlockData(block.id, {validation: option.value});
                    }}
                  />
                </div> */}
  </>
  );
}

function localizedString(data, baseKey, lang) {
  if (!data || baseKey == null) return '';
  if (lang === 'en') return data[`${baseKey}_en`] ?? data[baseKey] ?? '';
  if (lang === 'ru') return data[`${baseKey}_ru`] ?? data[baseKey] ?? '';
  return data[baseKey] ?? '';
}

function localizedDecisionField(item, baseKey, lang) {
  if (!item || baseKey == null) return '';
  if (lang === 'en') return item[`${baseKey}_en`] ?? item[baseKey] ?? '';
  if (lang === 'ru') return item[`${baseKey}_ru`] ?? item[baseKey] ?? '';
  return item[baseKey] ?? '';
}

function formatPreviewAcceptedFileTypes(acceptedTypes) {
  if (!acceptedTypes || !acceptedTypes.length) return '';
  return acceptedTypes
    .map((type) => String(type).replace(/^\./, '').toUpperCase())
    .join(', ');
}

function formatPreviewInputUploadDropHint(lang, acceptedTypes, sizeLimit) {
  const prefix =
    lang === 'en'
      ? 'Drag here or choose files'
      : lang === 'ru'
        ? 'Перетащите сюда или выберите файлы'
        : 'Lohista siia või vali failid';
  const parts = [prefix];
  const types = formatPreviewAcceptedFileTypes(acceptedTypes);
  if (types) parts.push(types);
  const hasSize =
    sizeLimit !== undefined && sizeLimit !== null && String(sizeLimit).trim() !== '';
  if (hasSize) {
    const sizeLabel =
      lang === 'en'
        ? `up to ${sizeLimit} MB`
        : lang === 'ru'
          ? `до ${sizeLimit} MB`
          : `kuni ${sizeLimit} MB`;
    parts.push(sizeLabel);
  }
  return parts.join(' · ');
}

export const PreviewComponent = ({bot={bot}, data, node, start, decisions, elements}) => {
  const { globalState } = useContext(GlobalStateContext);
  const lang = globalState.previewLanguage ?? 'default';

  const displayMode = data.displayMode || (data.isChoices ? 'choices' : 'buttons');

  const contentDisplayMode =
    data.messageDisplayMode ||
    data.messageDisplayMode_en ||
    data.messageDisplayMode_ru ||
    'message';

  const textBodyHtml =
    contentDisplayMode === 'html'
      ? localizedString(data, 'contentHtml', lang) || localizedString(data, 'content', lang)
      : localizedString(data, 'content', lang);

  const headtext = localizedString(data, 'headtext', lang);
  const progressheader = localizedString(data, 'progressheader', lang);
  const modallink = localizedString(data, 'modallink', lang);
  const notification = localizedString(data, 'notification', lang);
  const disclaimer = localizedString(data, 'disclaimer', lang);
  const buttontext = localizedString(data, 'buttontext', lang);
  const secondbutton = localizedString(data, 'secondbutton', lang);
  const validationMessage = localizedString(data, 'validationMessage', lang);
  const inputname = localizedString(data, 'inputname', lang);
  const hint = localizedString(data, 'hint', lang);
  const emailhint = localizedString(data, 'emailhint', lang);
  const defaultmessage = localizedString(data, 'defaultmessage', lang);
  const validationEmail = localizedString(data, 'validationEmail', lang);

  return (
    <>

      <div className={'block-body node'} id={node.id}>
      {/*     <div onClick={(e) => {
            e.preventDefault();
            window.saveblock = Math.random(10);
            logger.log(window.saveblock)
          }}>
            </div> */}
        
        {bot.progress !== undefined && 
          <Progress data={data} bot={bot} block={node} previewLanguage={lang} />
          }

            {start === node.id ? <span className="badge rounded-pill bg-success badge-tl">Start</span> : ''}

            <span className="rounded-pill  badge-bl">@{data.type}</span>

             <div className={`preview`}
               onClick={(e) => {
                e.preventDefault();
                setNode(node);
              }}
              >
                  <div className={`chat-body`}>
                     <div id="message-container">
            
                            <div className={'preview-container'}>
                                    {data.isProgress &&
                                    <div className={'progressheader'}>{progressheader}</div>
                                    }
                                    <div className={`preview-message`}>

                                        <h1>{headtext}</h1>
                                        

                                        {data.type === 'text' ||
                                        data.type === 'decision' ||
                                        data.type === 'input' ||
                                        data.type === 'inputupload' ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: textBodyHtml,
                                            }}
                                          />
                                        ) : (
                                          <p dangerouslySetInnerHTML={{__html: localizedString(data, 'content', lang)}}></p>
                                        )}

                                    </div>
                                  
                                  
                                    <div>
                                    <i className={`modallink`} >{modallink}</i>
                                    </div>

                            </div>
                        
                     </div>

                     <div className={'preview-container'}>


                          <div className={'preview-content'}>

                                    {data?.selecttype === "radio" && (    
                                          <div >       
                                            
                                            {data?.options  &&
                                                            Object.values(data?.options).map((item, index) => {
                                                              return (
                                                                <div key={index} className="choice position-relative">
                                                              
                                                                    {item.label}
                                                                    {item.hasUniqueFlow && <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />}


                                                                </div>
                                                              );
                                                })
                                              }
                                            

                                              {/* <div className={`validation`}></div>
                                                  
                                              <span  
                                                dangerouslySetInnerHTML={{__html: data.notification}} 
                                                className={`notification`}
                                              ></span> */}
                      
                                          
                                          </div>
                                    )}
                                    
                                    { data?.selecttype === 'select' && (
                                      <>
                                      <div className='inputname'>{inputname}</div>
                                      <div className='input'>
                                          <span className='dropdown left'><i class="fa fa-search"></i></span>
                                          <span className='dropdown right'><i class="fa fa-angle-down"></i></span>

                                        </div>

                                      {data?.options  &&
                                        Object.values(data?.options).map((item, index) => {
                                          return (
                                            <div key={index} className="mb-3 position-relative text-right zoom-option">
                              
                         
                                            {item.hasUniqueFlow && 
                                            <>
                                            {item.label}
                                            <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                                            </>
                                            }
                                            
                                          </div>
                                          );
                                      })
                                      }

                                      </>

                                    
                                    )}


                                    {data?.type === "share" && (
                                      <>
                                        <div className='inputname'>{emailhint}</div>
                                        <div className='flex'>
                                          <div className='input add'>{emailhint}</div>
                                          <button className='btn add'>+</button>    
                                        </div>
                                        <div className='input textarea'>{defaultmessage}</div>
                                        </>
                                        )                                                  
                                    }

                                    {data?.type === "decision" && displayMode === 'html' && (
                                      <>
                                        {Object.keys(decisions).map((key, i) => {
                                          const item = decisions[key];
                                          return (
                                            <div key={i} className="choice choice-expanded position-relative" style={{ display: 'flex' }}>
                                              <div style={{ flex: 1 }}
                                                dangerouslySetInnerHTML={{ __html: localizedDecisionField(item, 'html', lang) || '<em>no html</em>' }}
                                              />
                                              <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                                            </div>
                                          );
                                        })}
                                        <div className='btn'>{buttontext}</div>
                                      </>
                                    )}

                                    {data?.type === "decision" && displayMode === 'choices' && (
                                      <>
                                        {Object.keys(decisions).map((key, i) => {
                                          const item = decisions[key];
                                          const choiceContent = localizedDecisionField(item, 'content', lang);
                                          return (
                                            <div key={i} className="choice choice-expanded position-relative" style={{ display: 'flex' }}>
                                              {item.img && typeof item.img === 'string' && item.img.length > 3 && (
                                                <div className="choice-img">
                                                  <img src={item.img} alt="" />
                                                </div>
                                              )}
                                              <div style={{ flex: 1 }}>
                                                <div className="choice-title">{localizedDecisionField(item, 'text', lang)}</div>
                                                {choiceContent && choiceContent.length > 0 && (
                                                  <span className="choice-content" dangerouslySetInnerHTML={{ __html: choiceContent }} />
                                                )}
                                              </div>
                                              <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                                            </div>
                                          );
                                        })}
                                        <div className='btn'>{buttontext}</div>
                                      </>
                                    )}

                                    {data?.type === "decision" && displayMode === 'buttons' && 
                                       <> 
                                          {Object.keys(decisions).length > 2 ? (                   
                                                          Object.keys(decisions)                                                      
                                                          .map((key, i) => {
                                                            const item = decisions[key];
                                                              return (
                                                                <div key={i} className="choice position-relative">
                                                              
                                                                    {localizedDecisionField(item, 'text', lang)}
                                                                    <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />

                                                                </div>
                                                              );
                                                           })                                     
                                                           ) : (
                                                            
                                                           <>
                                                           </>
                                           )}     
                                                            
                                                                                                           
                                          </>                
                                        
                                                        
                                      }

                                    {data.type === "input" &&(
                                      <>
                                      <div className='inputname'>{inputname}</div>
                                      {data.inputtype === 'input' ?(
                                       <div className='input'>{hint}</div>
                                      ):(
                                      <div className='input textarea'>{hint}</div>)}
                                      </>
                                    )}

                                    {data.type === "inputupload" &&(
                                      <>
                                      <div className='inputname'>{inputname}</div>
                                      <div className='inputupload-field-card'>
                                        <div className='input textarea'>{hint}</div>
                                        <div className='inputupload-field-bar'>
                                          <span className='inputupload-field-bar-left'>
                                            <i className="fa fa-paperclip" aria-hidden="true" />
                                            <span>
                                              {lang === 'en'
                                                ? 'Add documents (optional)'
                                                : lang === 'ru'
                                                  ? 'Добавить документы (необязательно)'
                                                  : 'Lisa dokumendid (valikuline)'}
                                            </span>
                                          </span>
                                          <span className='inputupload-field-bar-right'>
                                            {lang === 'en'
                                              ? `up to ${data?.sizeLimit || ''} MB`
                                              : lang === 'ru'
                                                ? `до ${data?.sizeLimit || ''} MB`
                                                : `kuni ${data?.sizeLimit || ''} MB`}
                                          </span>
                                        </div>
                                      </div>
                                      </>
                                    )}

                                {/*     {data.type === "review" &&(
                                      
                                      Object.keys(elements)                                                      
                                      .map((key, i) => {
                                        const item = elements[key];
                                                <div key={i}>
                                                      <div className >{item.element.label}</div>
                                                      <div 
                                                     
                                                      className
                                                      ><i className={`fa fa-pencil`}></i>
                                                      </div>
                                                </div>
                                              })


                                       

                                      )} */}

                                    {data?.reviews &&
                                    Object.keys(data?.reviews)
                                        .sort()
                                        .map((key, i) => {
                                          const item = data.reviews[key];
                                          return (

                                              <div key={i}>
                                              <div className={'valuefield'} >{item.element.label}</div>
                                              <div 
                                             
                                              className
                                              ><i className={`fa fa-pencil`}></i>
                                              </div>
                                        </div>
                                      
                                            
                                          );
                                    })}



                                      {(notification !== '' && notification !== undefined)  && 
                                     <span  
                                          dangerouslySetInnerHTML={{__html: notification}} 
                                                className={`notification`}
                                              >

                                      </span>
                                    }


                                   {data.type === "share" &&(
                                  <div className={`validation`}>{validationEmail}</div>
                                  )}  
                                  <div className={`validation`}>{validationMessage}</div>
                                



                          </div>


                           {secondbutton && (
                                    <div className='mb-3 position-relative'>      
                                               <div className='btn btn-secondary'>{secondbutton}</div>
                                              <Handle id="next_secondary" className="block-handle block-handle-right preview" type="source_second" position="right" />
                                    </div>
                            )}

                            {data?.type === "decision" && displayMode === 'buttons' && 
                                       <> 
                                          {Object.keys(decisions).length === 1 ? (                   
                                                          Object.keys(decisions)                                                      
                                                          .map((key, i) => {
                                                            const item = decisions[key];
                                                              return (


                                                                <div key={i} className="position-relative">
                                                              
                                                                    <div className='btn'>{localizedDecisionField(item, 'text', lang)}</div>

                                                                    <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />

                                                                </div>
                                                              );
                                                           })                                     
                                                           ) : (
                                                            
                                                           <>
                                                           </>
                                           )}   
                                           {Object.keys(decisions).length === 2 ? (                   
                                                           <>
                                                               <div className="position-relative mb-3">
                                                                                                                              
                                                                    <div className='btn '>{localizedDecisionField(Object.values(decisions)[0], 'text', lang)}</div>

                                                                    <Handle id={Object.values(decisions)[0].id} className="block-handle block-handle-right" type="source" position="right" />

                                                                </div>

                                                                <div className="position-relative">
                                                              
                                                                    <div className='btn btn-secondary'>{localizedDecisionField(Object.values(decisions)[1], 'text', lang)}</div>

                                                                    <Handle id={Object.values(decisions)[1].id} className="block-handle block-handle-right" type="source" position="right" />

                                                                </div>

                                                            


                                                         </>
                                                           
                                                             
                                                                                              
                                                           ) : (
                                                            
                                                           <>
                                                           </>
                                           )}   
                                                                                           
                                         </>                
                                        
                                                        
                             }

                            {data.type === "inputupload" && disclaimer !== '' && disclaimer !== undefined && (
                              <span
                                dangerouslySetInnerHTML={{__html: disclaimer}}
                                className="disclaimer"
                              />
                            )}

                            {data.type === "login" && disclaimer !== '' && disclaimer !== undefined && (
                              <span
                                dangerouslySetInnerHTML={{__html: disclaimer}}
                                className="disclaimer"
                              />
                            )}

                            {(data.type === "text" && !data.button || data?.type === "decision" && Object.keys(decisions).length < 3)  ?(
                              <></> 
                            ):(data.type === "text" && data.button === undefined ) ? (
                              <div className='btn'>{buttontext}</div>
                            ) : (<div className='btn'>{buttontext}</div>)}






                         

                     </div>

                     

                  </div>
              </div>

              {data?.type === "payment" &&              

                <div className="position-relative position-left-right mb-3">
                  <div className="right">Fail
                  <Handle id="true" className="block-handle block-handle-right" type="source" position="right" /></div>
                  <div className="left">Success
                  <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>
                </div>

                }

                 {data?.type === "subscription" &&              

                <div className="position-relative position-left-right mb-3">
                   <div className="right">Ei Kehti
                  <Handle id="true" className="block-handle block-handle-right" type="source" position="right" /></div>
                  <div className="left">Kehtib
                  <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>
                </div>

                }

              


              <Handle id="source" className="block-handle text-center" type="target" position="top"></Handle>
              {(data.type === "text" || data.type === "input" || data.type === "multipleChoice" || data.type === "share" || data.type === "upload" || data.type === "inputupload" || data.type === "review") &&(
            <Handle id="next" className="block-handle text-center" type="source" position="bottom"></Handle>

           )}

          {(data.type === "decision") &&(
           <Handle id="next" className="block-handle text-center" type="source" position="bottom"></Handle>
           )}

      </div>
      {(data.type === "payment") &&(
            <>
          <span className="badge badge-variable bg-primary">payment_success</span>
          <span className="badge badge-variable bg-primary">pdf_link</span>
          <br/>
          <span className="badge badge-variable bg-primary">invoice_no</span>

          </>
          
           )}
      {(data?.type === "subscription") && (
            <>
          <span className="badge badge-variable bg-primary">subscription_invoice_no</span>
          <span className="badge badge-variable bg-primary">subscription_pdf_link</span>
            </>
           )}
      {(data.type === "input" && data.variable) && (
        <span className="badge badge-variable bg-primary">{data.variable}</span>
      )}
      {(data.type === "inputupload") && (
        <>
          {data.variable && (
            <span className="badge badge-variable bg-primary">{data.variable}</span>
          )}
          {data.uploadVariable && (
            <span className="badge badge-variable bg-primary">{data.uploadVariable}</span>
          )}
        </>
      )}
  </>
  );
}

export const NodeComponent = ({bot, name, icon, icons, data, node, start, routes}) => {
  const iconList = Array.isArray(icons) && icons.length > 0 ? icons : [icon];
  const multiIcon = iconList.length > 1;

  //const zoomoutcontent = zoom <= 1;
  const zoomoutcontent = true;
  return (
    <>
        <div className="" id={node.id}>


          

          {bot.progress === undefined || bot.progress === '' || bot.progress.length < 1 ? (
            <></>
          ):(
          <Progress data={data} bot={bot} block={node} />
          )
          }

          <div
            className={`node node-sm`}
            onClick={(e) => {
              e.preventDefault();
              setNode(node);
            }}
            
          >

            {start === node.id ? <span className="badge rounded-pill bg-success badge-tl">Start</span> : ''}


            <div className="node-header">
              <i
                className=""
                style={multiIcon ? {display: 'flex', alignItems: 'center', gap: 4} : undefined}
              >
                {iconList.map((ic, idx) => (
                  <img key={idx} src={'/images/icons/'+ic+'.png'} alt="" />
                ))}
              </i>
              <span> {name}</span>
            </div>

            {zoomoutcontent ? (
              <>
               
                 <div className='icon'>
                 <span
                   className='drag'
                   style={multiIcon ? {display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6} : undefined}
                 >
                    {iconList.map((ic, idx) => (
                      <img
                        key={idx}
                        src={'/images/icons/'+ic+'.png'}
                        alt=""
                        style={multiIcon ? {width: '44%', maxWidth: 56, height: 'auto', objectFit: 'contain'} : undefined}
                      />
                    ))}
                 </span>
                 </div>

                 {data?.type === 'text' && (
                    <div
                      className="node-text-preview"
                      style={{
                        fontSize: '10px',
                        textAlign: 'left',
                        marginTop: '6px',
                        maxHeight: '72px',
                        overflow: 'hidden',
                        lineHeight: 1.3,
                      }}
                    >
                      {data.headtext ? (
                        <div style={{fontWeight: 'bold', marginBottom: '4px'}}>{data.headtext}</div>
                      ) : null}
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            (data.messageDisplayMode ||
                              data.messageDisplayMode_en ||
                              data.messageDisplayMode_ru ||
                              'message') === 'html'
                              ? data.contentHtml || data.content || ''
                              : data.content || '',
                        }}
                      />
                    </div>
                  )}

                 {/*  These are essentially same, should be able to unify */}

                 {data?.type === "decision" &&
                      Object.keys(routes)        
                                      
                        .map((key, i) => {
                          const item = routes[key];
                          return (
                            <div key={i} className="mb-3 position-relative text-right zoom-option">
                              {item.text}
                              <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                          </div>
                      );
                    })                                     
                  }


                  {data?.options &&
                  Object.values(data?.options).map((item, index) => {
                          return (
                            <div key={index} className="mb-3 position-relative text-right zoom-option">
                              
                         
                              {item.hasUniqueFlow && 
                              <>
                              {item.label}
                              <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                              </>
                              }
                              
                            </div>
                          );
                        })
                  }


          
                    {data.secondbutton && (
                                  <div className='mb-3 position-relative'>      
                                    <Handle id="next_secondary" className="block-handle block-handle-right" type="source_second" position="right" />
                                </div>
                          
                    )}

                </>
            ):(

              <>

                        <div className="my-3 header"><b>{data.headtext}</b></div>



                      {/*  These are essentially same, should be able to unify */}

                        {data?.type === "decision" &&   
                       
                                    Object.keys(routes)
                                            .sort()
                                            .map((key, i) => {
                                              const item = routes[key];
                                              return (
                                                <div key={i} className="mb-3 position-relative">
                                                  {item.text}
                                                  <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />
                                                </div>
                                              );
                                      }) 
                                            
                                             
                      }



                      {data?.options &&
                      Object.values(data?.options).map((item, index) => {
                              return (
                                <div key={index} className="my-3 position-relative">
                                  <span>
                                  {item.label}
                                  </span>
                                  {item.hasUniqueFlow && <Handle id={item.id} className="block-handle block-handle-right" type="source" position="right" />}
                                  
                                </div>
                              );
                            })
                      }

                      {data?.reviews &&
                        Object.keys(data?.reviews)
                            .sort()
                            .map((key, i) => {
                              const item = data.reviews[key];
                              return (

                                  <p key={i}>{item.element.label}</p>
                          
                                
                              );
                        })}


                    

                        {data.secondbutton && (
                                      <div className='mb-3 position-relative'>      
                                        <div className='node-button'>{data.secondbutton}</div>
                                        <Handle id="next_secondary" className="block-handle block-handle-right" type="source_second" position="right" />
                                    </div>
                              
                        )}




                        <div className='node-button'>{data.buttontext}</div>
                    </>

            )}



            {data?.type === "payment"  &&              

                  <div className="position-relative position-left-right">
                    <div className="right">New client
                    <Handle id="true" className="block-handle block-handle-right" type="source" position="right" /></div>
                    <div className="left">Existing client
                    <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>
                  </div>

            }

     

            <span className="badge badge-variable bg-primary">{data.variable}</span>
            {(data.type === "inputupload" && data.uploadVariable) && (
              <span className="badge badge-variable bg-primary">{data.uploadVariable}</span>
            )}

        
          </div>

         

  
           <Handle id="source" className="block-handle text-center" type="target" position="top"></Handle>
          
          {(data.type === "text" || data.type === "input" || data.type === "multipleChoice" || data.type === "share" || data.type === "upload" || data.type === "inputupload" || data.type === "review" || data.type === "decision") &&(
            <Handle id="next" className="block-handle text-center" type="source" position="bottom"></Handle>

           )}


        </div>

        {(data.type === "payment") &&(
            <>
          <span className="badge badge-variable bg-primary">payment_success</span>
          <span className="badge badge-variable bg-primary">pdf_link</span>
          <br/>
          <span className="badge badge-variable bg-primary">invoice_no</span>

          </>
          
          )}
        {(data?.type === "subscription") && (
            <>
          <span className="badge badge-variable bg-primary">subscription_invoice_no</span>
          <span className="badge badge-variable bg-primary">subscription_pdf_link</span>
            </>
          )}
    


  

    </>
  );
}



export const IntNodeComponent = ({bot, name, icon, data, node, start}) => {
  

  return (
    <> 
     <div className="node int" id={node.id}>
  
  
        {(node.type === "loginBlock" || node.type === "matchBlock" || node.type === "matchV2Block" || node.type === 'calendarBlock') && (
          <Progress data={data} bot={bot} block={node} />
        )}
           
          
        

        <div className={``}
         onClick={(e) => {
          e.preventDefault();
          setNode(node);
          }}>
          
          {start === node.id ? <span className="badge rounded-pill bg-success badge-tl">Start</span> : ''}
         
          <div className="node-header"><i className=""><img src={blockIconSrc(icon)} alt="..." /></i><span> {name}</span></div>



          <div className='icon integration'>
                 <span className='drag'>
                    <img src={blockIconSrc(icon)} alt="..." />
                 </span>
                 </div>



          {data?.type === "invoice" &&              
                <div className="mb-3 position-relative">
                <span className="fw-bolder left">FAIL</span> Load Invoice Data <span className="fw-bolder right">OK</span>
                <Handle id="nextOnSuccess" className="block-handle block-handle-right" type="source" position="right" />
                <Handle id="nextOnFail" className="block-handle block-handle-left" type="source" position="left" />
                </div>
          }

          {data?.type === "condition" &&              
                <div className="mb-3 position-relative">
                <span className="fw-bolder left">F</span> {data.variable} {data.operator} {data.value}{' '}
                <span className="fw-bolder right">T</span>
                <Handle id="true" className="block-handle block-handle-right" type="source" position="right" />
                <Handle id="false" className="block-handle block-handle-left" type="source" position="left" />
                </div>
          }

          {data?.type === "subscriptioncheck" &&
                <div className="mb-3 position-relative">
                <span className="fw-bolder left">F</span> Subscription active? <span className="fw-bolder right">T</span>
                <Handle id="true" className="block-handle block-handle-right" type="source" position="right" />
                <Handle id="false" className="block-handle block-handle-left" type="source" position="left" />
                </div>
          }

          {data?.type === "gtm" && (
                <div className="mb-3">
                  <span className="badge bg-success" style={{fontSize: '12px'}}>
                    {data.event || 'hugo-default-gtm-event'}
                  </span>
                </div>
          )}

            {data?.type === "scoro"  &&              

            <div className="position-relative position-left-right">

              
             <div className='left'>TIMESLOT error:      
                              <Handle id="next_secondary" className="block-handle block-handle-left" type="source_second" position="left" />
               </div>
              
           
              <div className="right">New client
              <Handle id="true" className="block-handle" type="source" position="bottom" /></div>

              <div className="right">Existing client
              <Handle id="false" className="block-handle block-handle-right" type="source" position="right" /></div>


            </div>

            

            }

            {data?.type === "match"  &&              

            <div className="position-relative position-left-right">
              
              <div className="left">No match
              <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>

          
            </div>

            }

            {data?.type === "matchV2"  &&              

            <div className="position-relative position-left-right">
              
              <div className="left">No match
              <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>

          
            </div>

            }

            {data?.type === "calendar"  &&              

            <div className="position-relative position-left-right">
              
              <div className="left">NO TIMESLOTS
              <Handle id="false" className="block-handle block-handle-left" type="source" position="left" /></div>


            </div>

            }

          {data?.type === "project" && data?.require_client_account === true && (
            <div className="position-relative position-left-right">
              <div className="left">client not found
              <Handle id="nextOnNoClient" className="block-handle block-handle-left" type="source" position="left" /></div>
            </div>
          )}

          {data?.type === "project" && data?.require_client_account !== true && (
            <div className="position-relative position-left-right">
              <div className="left">email not defined
              <Handle id="nextOnNoEmail" className="block-handle block-handle-left" type="source" position="left" /></div>
            </div>
          )}

          {data?.type === "calculation" &&              
              <> 
              <h4>CALCULATION</h4>
              {data.method === 'math' ?(
              <div className="my-3" dangerouslySetInnerHTML={{__html: data.formula}} />
              ):(<div className="my-3" dangerouslySetInnerHTML={{__html: 'Date Duration'}} />
              )}
              </>
          }

          {data?.type === "data" && (  
               <div className='mb-3 position-relative'>
                <b>{data?.datatype}</b>
                </div>
              )
          }
          {data?.type === "teleport" && (  
               <div className='mb-3 position-relative'>
                <span>{data?.bot}</span>
                </div>
              )
          }
          {data?.type === "data" && data.data !== undefined && ( 

                Object.entries(data.data).map(([key, { text, value }]) => (
                  <div key={key} className="position-relative">
                    {text}
                  </div>
                ))
                
          )
          }


          {data?.type === "document" && (  
                <>
               <p>{data.documentName}</p>
              <br/>
               </>
               
              )
          }

          {data?.type === "sheet" && (  
                <>
               <p>{data.documentName}</p>
               <br/>
               </>
               
              )
          }


{data?.type === "project" && (  
                <>
               <p>{data.project_name}</p>
               <br/>
               </>
               
              )
          }
          
          {data?.type === "email" && (  
                <>
                  <p>Email Variable: {data.email}</p>
               </>
               
              )
          }

          
          {/* AI block: show multiple variable names in multiple mode */}
          {(data.type === "ai" && data.outputMode === "multiple" && data.outputMappings?.length > 0) && (
            <>
              {data.outputMappings.map((mapping) => (
                <span key={mapping.id || mapping.variable} className="badge badge-variable bg-primary">
                  {mapping.variable}
                </span>
              ))}
            </>
          )}

          {data?.type === "ai" && data?.routingEnabled && data?.routes && (
            <>
              {Object.values(data.routes).map((route) => (
                <div key={route.id} className="mb-3 position-relative">
                  <span>{route.value}</span>
                  <Handle id={route.id} className="block-handle block-handle-right" type="source" position="right" />
                </div>
              ))}
              <div className="mb-3 position-relative">
                <span className="fw-bolder left">Fallback</span>
                <Handle id="nextOnFallback" className="block-handle block-handle-left" type="source" position="left" />
              </div>
            </>
          )}

          {data?.type === "router" && data?.routes && (
            <>
              {Object.values(data.routes).map((route) => (
                <div key={route.id} className="mb-3 position-relative">
                  <span>{route.value}</span>
                  <Handle id={route.id} className="block-handle block-handle-right" type="source" position="right" />
                </div>
              ))}
              <div className="mb-3 position-relative">
                <span className="fw-bolder left">Fallback</span>
                <Handle id="nextOnFallback" className="block-handle block-handle-left" type="source" position="left" />
              </div>
            </>
          )}
          
          {/* AI block in single mode or other blocks */}
          {(data.type !== "condition" && data.type !== "ai" && data.type !== "router" && data.type !== "gtm" && data.type !== "subscriptioncheck" && data.type !== "classify") && (
            <span className="badge badge-variable bg-primary">{data.variable}</span>
          )}
          
          {/* AI block in single mode */}
          {(data.type === "ai" && (data.outputMode !== "multiple" || !data.outputMappings?.length)) && (
            <span className="badge badge-variable bg-primary">{data.variable}</span>
          )}

          {(data.type === "router" && data.variable) && (
            <span className="badge badge-variable bg-primary">{data.variable}</span>
          )}

          {data.type === "inputupload" && (
            <span className="badge badge-variable bg-primary">{data.uploadVariable}</span>
          )}
           
          {(data.type === "calendar") &&(
            <>
          <span className="badge badge-variable bg-primary">slot</span>
          <span className="badge badge-variable bg-primary">slot_date</span>
          <span className="badge badge-variable bg-primary">slot_address</span>
          </>
           )}

         {(data.type === "scoro") &&(
            <>
          <span className="badge badge-variable bg-primary">project_id</span>
          </>
           )}
           
         {(data.type === "scoro" && data.product === 24) &&(
            <>
          <span className="badge badge-variable bg-primary">scoro_invoice</span>
          </>
           )}

{(data.type === "login") &&(
            <>
          <span className="badge badge-variable bg-primary">firstname</span>
          <span className="badge badge-variable bg-primary">lastname</span>
          <span className="badge badge-variable bg-primary">phone</span>
          <span className="badge badge-variable bg-primary">email</span>
          <span className="badge badge-variable bg-primary">pid</span>
          </>
           )}

         {(data.type === "invoice") &&(
          <>
          <span className="badge badge-variable bg-primary">invoice_no</span>
          <span className="badge badge-variable bg-primary">amount</span>
          <span className="badge badge-variable bg-primary">amount_total</span>
          <span className="badge badge-variable bg-primary">prepayment_applied</span>
          <span className="badge badge-variable bg-primary">client_name</span>
          <span className="badge badge-variable bg-primary">client_email</span>
          <span className="badge badge-variable bg-primary">client_type</span>
          <span className="badge badge-variable bg-primary">partner_name</span>
          <span className="badge badge-variable bg-primary">partner_email</span>
          </>
           )}

         {(data.type === "match") &&(
          <>
          <span className="badge badge-variable bg-primary">lawyer</span>
          <span className="badge badge-variable bg-primary">selected_service_price</span>
          <span className="badge badge-variable bg-primary">partner_email</span>
          <span className="badge badge-variable bg-primary">partner_name</span>
          <span className="badge badge-variable bg-primary">partner_company_name</span>
          <span className="badge badge-variable bg-primary">partner_company_reg_id</span>
          <span className="badge badge-variable bg-primary">partner_company_vat_id</span>
          <span className="badge badge-variable bg-primary">partner_company_address</span>
          <span className="badge badge-variable bg-primary">partner_hourlyprice</span>
          <span className="badge badge-variable bg-primary">partner_videocall_url</span>
          <span className="badge badge-variable bg-primary">partner_crm_id</span>
          <span className="badge badge-variable bg-primary">lawyer_profile</span>
          <span className="badge badge-variable bg-primary">lawyer_img</span>




          </>
          )}

         {(data.type === "matchV2") &&(
          <>
          <span className="badge badge-variable bg-primary">partner_name</span>
          <span className="badge badge-variable bg-primary">partner_company_name</span>
          <span className="badge badge-variable bg-primary">partner_crm_id</span>
          <span className="badge badge-variable bg-primary">selected_service_price</span>
          <span className="badge badge-variable bg-primary">client_type</span>
          <span className="badge badge-variable bg-primary">legal_field_ids</span>
          <span className="badge badge-variable bg-primary">subject</span>
          </>
          )}

         {(data.type === "classify") &&(
          <>
          <span className="badge badge-variable bg-primary">legal_field_ids</span>
          <span className="badge badge-variable bg-primary">subject</span>
          </>
          )}




         
                {data.secondbutton && (
                                  <div className='mb-3 position-relative'>      
                                    <Handle id="next_secondary" className="block-handle block-handle-right" type="source_second" position="right" />
                                </div>
                          
                    )}


        </div>


        {data?.type === "gtm" ? (
          <Handle id="source" className="block-handle" type="target" position="top" />
        ) : (
          <Handle id="target" className="block-handle" type="target" position="top" />
        )}
          
          {(data?.type !== "condition" && data?.type !== "subscriptioncheck" && data?.type !== "teleport" && data?.type !== "scoro" && data?.type !== "router" && !(data?.type === "ai" && data?.routingEnabled)) &&
           <Handle id="next" className="block-handle" type="source" position="bottom" />
           }
         
          
      
        </div>

       
    </>
  );
}




export const ProgressOld = ({bot, block, data, onChange}) => {

  

  const optionSelectRef = useRef(null);
  const [progs, setProgs] = useState([{id: '00', label: 'off', value: 'off', step: 'off'}, ...bot.progress])
  const maxprogress = bot.progress.length;

    const formatOptionLabel = ({ label }, { context }) => {
      if (context === 'menu') {
        const index = bot.progress.findIndex((option) => option.label === label);
        if(index === -1){
          return (
            
            <div>
                {label}
            </div>
            )  
          
        }else{
        return (
          <>
          <div>
             {index + 1}
          </div>
          <span>{label}</span>
          </>
        );
        }
      } else if (context === 'value') {
   
            const index = bot.progress.findIndex((option) => option.label === label);
            return (       
                  <div>
                  {index + 1}
                  </div>
            );    
      }


      return label;
    };
    const [selectedOption, setSelectedOption] = useState(data.progressheader);
    const [closed, setClosed] = useState(false);

    /* Using this to close react component globally. Not the best approach. */
    useEffect(() => {
      if(window.progress !== block.id){
        setClosed(false)
      }
    }, [window.progress])
  

    const handleSelectChange = async(selectedOption) => {
      setSelectedOption(selectedOption);
    };

    useEffect(() => {
      if(optionSelectRef.current === null) return
      if(optionSelectRef.current.state.value){
        Chatbot.setBlockData(block.id, {isProgress: true, progress: optionSelectRef.current.state.value.step, progressheader: optionSelectRef.current.state.value.value, progressheader_en: optionSelectRef.current.state.value.value}, true);
        if (optionSelectRef.current.state.value.step === 'off') {
          Chatbot.setBlockData(block.id, {isProgress: false, progress: '+'}, true);
          setSelectedOption('+');
        }
      }
      setClosed(closed ? false : true, closed ? true : false)
    }, [selectedOption]);
    
    const handleOpen = () => {
      setClosed(closed ? false : true, closed ? true : false)
      window.progress = block.id;
    }


  return (
    <>
   {/*   <div  onClick={()=> {setClosed(closed ? false : true, closed ? true : false)}}>
            closed 
            </div> */}
           <div className={'progress-indicator'}>
                    <table width={100 * data.progress / maxprogress + '%'} className={'progress'}></table>
          </div>


        {!closed ? (
          <div  className='progress-select-icon' onClick={()=> {handleOpen()}}>
            {data.progress === undefined ?('+'):(data.progress)}
            {data.disableHistory && (
              <i className="fa fa-lock" style={{
                position: 'absolute',
                top: '0px',
                right: '0px',
                fontSize: '16px',
                color: '#ffa0a9',
                zIndex: 10
              }} title="History disabled - Moving back is not allowed from this block"></i>
            )}
          </div>
        ):(


       <>

        

          <div className="mb-2 nodrag absolute">
                     
                      <Select             
                      ref={optionSelectRef}
                      autoFocus={false}
                      defaultMenuIsOpen={false}
                      options={progs}
                      menuIsOpen={true}
                      id="choice"
                      name="choice"
                      className={selectedOption?.value === "off" || data.isProgress !== true ? "progress-off progress-container" : "progress-container"}
                      placeholder={data.isProgress === true ? data.progress : '+'}
                      defaultValue={data.progressheader}
                      value={selectedOption}
                      classNamePrefix="progress-select"
                      menuPlacement="bottom"
                      formatOptionLabel={formatOptionLabel}                    
                      onChange={handleSelectChange}
                      onBlur={async (e) => {
                
                      /*   if(optionSelectRef.current.state.value){
                            Chatbot.setBlockData(block.id, {isProgress: true, progress: optionSelectRef.current.state.value.step, progressheader: optionSelectRef.current.state.value.value}, true);
                            if (optionSelectRef.current.state.value.step === 'off') {
                              Chatbot.setBlockData(block.id, {isProgress: false, progress: '+'}, true);
                              setSelectedOption('+');
                            }
                          } ; */
                         /*  setClosed(closed ? false : true, closed ? true : false) */
                        }}
                      />
             
               </div>
               </>
               )}
    </>
  );
}


export const Progress = ({ bot, block, data, onChange, previewLanguage = 'default' }) => {
  const optionSelectRef = useRef(null);

  // Set up progress options, including a default 'off' option
  const progressList = bot?.progress || [];
  const [progs, setProgs] = useState([{ id: '00', label: 'off', value: 'off', step: 'off' }, ...progressList]);
  const maxprogress = progressList.length;
  const [selectedOption, setSelectedOption] = useState(data.progressheader);
  const [closed, setClosed] = useState(false);

  // Format options with step index display
  const formatOptionLabel = (option, { context }) => {
    const { label } = option;
    const displayLabel = localizedString(option, 'label', previewLanguage);
    if (context === 'menu') {
      const index = progressList.findIndex((o) => o.label === label);
      if(index === -1){
        return (
          
          <div>
              {displayLabel}
          </div>
          )  
        
      }else{
      return (
        <>
        <div>
           {index + 1}
        </div>
        <span>{displayLabel}</span>
        </>
      );
      }
    } else if (context === 'value') {
 
          const index = progressList.findIndex((o) => o.label === label);
          return (       
                <div>
                {index + 1}
                </div>
          );    
    }


    return displayLabel;
  };

  // Helper to get progress headers based on progressList and selected step
  const getProgressHeaders = (step) => {
    const selectedProgress = progressList.find((option) => option.step === step);
    if (selectedProgress) {
      return {
        progressheader: selectedProgress.label || '',
        progressheader_en: selectedProgress.label_en || '',
        progressheader_ru: selectedProgress.label_ru || '',
      };
    }
    return { progressheader: '', progressheader_en: '', progressheader_ru: '' };
  };

  // Synchronize progress data with locale-specific headers
  useEffect(() => {
    if (optionSelectRef.current === null) return;

    const { step, value } = optionSelectRef.current.state.value || {};
    if (step !== undefined) {
      const headers = getProgressHeaders(step);

      // Set progress data with locale-specific headers
      Chatbot.setBlockData(block.id, {
        isProgress: step !== 'off',
        progress: step !== 'off' ? step : '+',
        ...headers
      }, true);

      setSelectedOption(step === 'off' ? '+' : value);
    }

    setClosed(false);
  }, [selectedOption]);

  // Effect to close component globally if window.progress changes
  useEffect(() => {
    if (window.progress !== block.id) {
      setClosed(false);
    }
  }, [window.progress]);

  const handleSelectChange = async (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleOpen = () => {
    setClosed((prevClosed) => !prevClosed);
    window.progress = block.id;
  };

  return (
    <>
      <div className='progress-indicator'>
        <table width={`${(100 * data.progress) / maxprogress}%`} className='progress'></table>
      </div>

      {!closed ? (
        <div className='progress-select-icon' onClick={handleOpen}>
          {data.progress === undefined ? '+' : data.progress}
          {data.disableHistory && (
            <i className="fa fa-lock" style={{
              position: 'absolute',
              top: '0px',
              right: '0px',
              fontSize: '16px',
              color: '#ffa0a9',
              zIndex: 10
            }} title="History disabled - Moving back is not allowed from this block"></i>
          )}
        </div>
      ) : (
        <div className="mb-2 nodrag absolute">
          <Select
            ref={optionSelectRef}
            autoFocus={false}
            defaultMenuIsOpen={false}
            options={progs}
            menuIsOpen={true}
            id="choice"
            name="choice"
            className={`progress-container ${selectedOption?.value === 'off' || data.isProgress !== true ? "progress-off" : ""}`}
            placeholder={data.isProgress ? data.progress : '+'}
            defaultValue={data.progressheader}
            value={selectedOption}
            classNamePrefix="progress-select"
            menuPlacement="bottom"
            formatOptionLabel={formatOptionLabel}
            onChange={handleSelectChange}
          />
        </div>
      )}
    </>
  );
};
